class FooterAccordion {
  constructor() {
    this.footerTitles = document.querySelectorAll('.c-footer__column-title');
    this.setupEventListeners();
  }

  setupEventListeners() {
    this.footerTitles?.forEach((title) => {
      title?.addEventListener('click', this.toggleList.bind(this));
    });
  }

  toggleList(event) {
    const title = event.currentTarget;
    const list = title?.nextElementSibling;

    if (list && list?.classList.contains('c-footer__list')) {
      list.classList.toggle('is-visible');
      title.classList.toggle('is-open');
    }
  }
}

new FooterAccordion();
